import React from 'react';

export const ArrowLeft = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
            <g
                id="Group_2689"
                data-name="Group 2689"
                transform="translate(-1514.426 -203.719)"
                opacity="0.7"
            >
                <circle
                    id="Ellipse_111"
                    data-name="Ellipse 111"
                    cx="6.5"
                    cy="6.5"
                    r="6.5"
                    transform="translate(1514.426 203.719)"
                    fill="#36373c"
                />
                <path
                    id="Icon_awesome-arrow-alt-circle-left"
                    data-name="Icon awesome-arrow-alt-circle-left"
                    d="M10.934,6.375H7.629V4.355a.342.342,0,0,0-.584-.242L3.788,7.386a.339.339,0,0,0,0,.482l3.257,3.274a.342.342,0,0,0,.584-.242V8.882h3.305a.343.343,0,0,0,.342-.342V6.717A.343.343,0,0,0,10.934,6.375Z"
                    transform="translate(1513.444 202.591)"
                    fill="#fff"
                />
            </g>
        </svg>
    );
};
